import { LockOpen } from "@phosphor-icons/react";
import * as Dialog from "@radix-ui/react-dialog";
import classNames from "classnames";
import { AnimatePresence } from "framer-motion";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { Modal } from "~/components/Modal";
import { SendResetPasswordDialogForm } from "~/components/SendResetPasswordDialogForm";
import {
  IS_PRF_TEMPLATE,
  IS_TJPR_TEMPLATE,
  IS_TRN_TEMPLATE,
} from "~/utils/constants";

interface ForgotPasswordProps {}

export const ForgotPassword: React.FC<ForgotPasswordProps> = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const t = useTranslations();

  function handleCloseModal() {
    setIsModalOpen(false);
  }

  return (
    <Dialog.Root open={isModalOpen} onOpenChange={setIsModalOpen}>
      <Dialog.Trigger
        type="button"
        className={classNames(
          "flex items-center xs:gap-2 xl:gap-0 2xl:gap-2 rounded text-app-gray-230 text-xs focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-app-blue-500 hover:underline xs:text-sm xl:text-xs",
          IS_TRN_TEMPLATE && "text-black",
          IS_TJPR_TEMPLATE && "bg-app-gray-950",
          IS_PRF_TEMPLATE && "text-black",
        )}
      >
        {t("forgot-pass")}
        <LockOpen className="xl:text-xs 2xl:text-lg" weight="bold" />
      </Dialog.Trigger>

      <AnimatePresence>
        {isModalOpen && (
          <Modal>
            <SendResetPasswordDialogForm onClose={handleCloseModal} />
          </Modal>
        )}
      </AnimatePresence>
    </Dialog.Root>
  );
};
